import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bs-status", {
            'bs-status--gray': _ctx.color === 'gray',
            'bs-status--green': _ctx.color === 'green',
            'bs-status--royal-blue': _ctx.color === 'royal-blue',
            'bs-status--purple': _ctx.color === 'purple',
            'bs-status--red': _ctx.color === 'red',
            'bs-status--orange': _ctx.color === 'orange',
        }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}